export default {
      id: "unactive-client-usage",
      viewBox: "0 0 12 12",
      url: "assets/" + "sprite.svg#unactive-client-usage",
      toString: function () {
        return this.url;
      }
    }